import { createContext, useContext } from 'react';
import { OverlayTriggerState } from 'react-stately';

export const ActiveOverlayStateContext = createContext<OverlayTriggerState | null>(null);

export default function useActiveOverlayState() {
  return useContext(ActiveOverlayStateContext);
}
